import styles from './BackButton.module.scss';
import {useLocation, useNavigate} from "react-router-dom";

export function BackButton() {

  const navigate = useNavigate()
  const location = useLocation()

  const isRootPath = location.pathname === "/"

  const click = (event) => {
    event.preventDefault()
    navigate(-1)
  }

  return (
    <>
      { !isRootPath &&
        <a className={styles.BackButton} href={"/"} onClick={click}>Zurück</a>
      }
    </>
  );
}